import { render } from "./Muro.vue?vue&type=template&id=82179ae0&scoped=true"
import script from "./Muro.vue?vue&type=script&lang=js"
export * from "./Muro.vue?vue&type=script&lang=js"

import "./Muro.vue?vue&type=style&index=0&id=82179ae0&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82179ae0"]])

export default __exports__